export const removeInvalidState = (state, communityId) =>
    Object.keys(state)
        .filter(
            serialisedSearchCriteria =>
                serialisedSearchCriteria.indexOf(
                    `communityId=${communityId}`
                ) === -1
        )
        .reduce((previousState, currentKey) => {
            previousState[currentKey] = state[currentKey]
            return previousState
        }, {})
